import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';

const reArrangeMenuService = {
  add(payload: {
    menu_name: string;
    menu_detail_id: number;
    rearrange_index: number;
    is_rearrange_sub_menu?: boolean;
  }): Promise<CommonResponse<any>> {
    const url = '/rearrange-menus';
    return axiosClient.post(url, payload);
  },
  getNextReArrangeMenuIndex(): Promise<CommonResponse<number>> {
    const url = '/rearrange-menu/get-next-index';
    return axiosClient.get(url);
  },
};

export default reArrangeMenuService;
